export const config = {
  title: "D'Amario Paving and Concrete Construction",
  meta: {
    description:
      "D'Amario Paving and Concrete Construction offers quality concrete, paving, and excavation services in Philadelphia, PA, backed by 25+ years of experience and licensed expertise.",
    keywords: [
      "Philadelphia concrete paving",
      "D'Amario Concrete Construction",
      "driveway paving Philadelphia",
      "excavation services PA",
      "retaining wall contractor"
    ],
    author: "D'Amario Paving and Concrete Construction",
    canonicalUrl: "https://www.damarioconcreteconstruction.com/",
  },
  sections: {
    header: { businessName: "D'Amario Paving and Concrete Construction" },
    sectionB: {
      heroTitle: "D'Amario Paving & Concrete Construction",
      heroSubtitle: "Quality Concrete, Paving & Excavation in Philadelphia, PA",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "2159746540",
      phoneLabel: "(215) 974‑6540",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/502790008/photo/builders-and-paving.jpg?s=612x612&w=0&k=20&c=dBTIbw0xaq4n2L9cyeqc1S_uoD52hqQj6kKsw6536cg=",
      cardData: [
        {
          title: "Concrete Services",
          description:
            "Durable concrete solutions for driveways, patios, sidewalks & slabs.",
        },
        {
          title: "Paving",
          description:
            "Residential and commercial paving with Cambridge stones & asphalt.",
        },
        {
          title: "Excavation",
          description:
            "Expert site prep, trenching, land clearing and excavation works.",
        },
      ],
      description:
        "With over 25 years of licensed experience, D'Amario delivers expert concrete, paving, and excavation services around Philadelphia with a focus on craftsmanship and customer satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From residential driveways to commercial parking lots, we offer comprehensive paving and excavation services.",
      cards: [
        {
          title: "Concrete",
          description: "High-quality slabs, sidewalks, patios, and more.",
          imageSrc: "https://media.istockphoto.com/id/2163402467/photo/road-construction-with-sand-filling-and-horizon-in-the-background.jpg?s=612x612&w=0&k=20&c=X-aQXcnXIGkUu0IXwA4B5zX-BP2ZfQKLFoG8OSYxRNA=",
          imageAlt: "Concrete Work",
        },
        {
          title: "Paving",
          description:
            "Cambridge pavers, asphalt, retaining walls and decorative surfaces.",
          imageSrc: "https://media.istockphoto.com/id/2196785709/photo/the-bucket-of-a-mini-loader-which-carries-a-fully-loaded-red-brick-down-the-street-an-example.jpg?s=612x612&w=0&k=20&c=zoUWbGpIyg6_eUavMoelZQCAmiY9rF4cKvy1ejub7Ns=",
          imageAlt: "Paving Services",
        },
        {
          title: "Excavation",
          description:
            "Site preparation, trenching, land clearing services.",
          imageSrc: "https://media.istockphoto.com/id/2014842424/photo/hydraulic-breaker-breaking-up-old-cobblestones.jpg?s=612x612&w=0&k=20&c=na7IcACe1XQGoyqYnG7uSNEZDcQmkyb_Ie6qF_CGFw8=",
          imageAlt: "Excavation Work",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Retaining Walls",
        "Deck Rebuilds",
        "Hardscape Installation",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://static.wixstatic.com/media/694639_f8b0150b1e0f46ce95c9db6ac682e60d~mv2.png/v1/fill/w_395,h_381,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/694639_f8b0150b1e0f46ce95c9db6ac682e60d~mv2.png",
        alt: "D'Amario Construction Team",
      },
      aboutText: [
        "Founded by Nick D’Amario Jr., D'Amario Paving and Concrete Construction has 25+ years of experience in Philadelphia.",  
        "We're licensed, insured, and dedicated to delivering expert craftsmanship and professional service.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "D'Amario Construction Logo",
      businessName: "D'Amario Paving and Concrete Construction",
      contact: {
        phone: "2159746540",
        phoneLabel: "(215) 974‑6540",
        email: "DamarioConcreteConstruction@gmail.com",
        website: "https://www.damarioconcreteconstruction.com/",
        address: "9228 Bluegrass Rd, Philadelphia, PA 19114, USA",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "9228 Bluegrass Rd, Philadelphia, PA 19114, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3051.123456!2d-75.012345!3d39.944123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c8e6a1b12345%3A0xa1b2c3d4e5f6g7h8!2s9228%20Bluegrass%20Rd%2C%20Philadelphia%2C%20PA%2019114%2C%20USA!5e0!3m2!1sen!2sus!4v1718850000000!5m2!1sen!2sus",
    },
  },
};

export default config;
